import React, {useState} from 'react';
import {HiOutlineMinus, HiOutlinePlus} from 'react-icons/hi';
import {FiHome} from 'react-icons/fi';
import {CgMenuGridO} from 'react-icons/cg';
import {useCurrentUser} from '../../../../contexts/UserContext';
import {useViewerStore} from "../../../../store/store";
import {registerRef} from "../../../../helpers/storeHelpers";

const Navigation: React.FC = () => {
    const {hasCapability} = useCurrentUser();
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const [isXRayView, setIsXRayView] = useState<boolean>(true);

    const zoomInHandler = () => {
        sceneViewer?.setCameraZoom(-10);
    };

    const zoomOutHandler = () => {
        sceneViewer?.setCameraZoom(10);
    };

    const homePositionHandler = () => {
        sceneViewer?.setCameraView(sceneViewer.viewMode, true);
    };

    const xRayViewHandler = () => {
        if (sceneViewer) {
            sceneViewer.setVisibleGroup('roof', !isXRayView);
            setIsXRayView(prev => !prev);
        }
    };

    return (
        <div className='navigation'>
            <button onClick={zoomInHandler} className='navigation__btn' title='Zoom In'>
                <HiOutlinePlus/>
            </button>
            <button
                ref={registerRef('defaultPositionBtn')}
                onClick={homePositionHandler}
                className='navigation__btn'
                title='Site View'
            >
                <FiHome/>
            </button>
            {hasCapability('X-Ray_View') && (
                <button
                    ref={registerRef('btnXRay')}
                    onClick={xRayViewHandler}
                    className='navigation__btn'
                    title='X-Ray View'
                >
                    <CgMenuGridO/>
                </button>
            )}
            <button onClick={zoomOutHandler} className='navigation__btn' title='Zoom Out'>
                <HiOutlineMinus/>
            </button>
        </div>
    );
};

export default Navigation;